import { CancelButton, GroupButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { ListView } from '@core/components/List';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Competencia, DataBR } from '@format/DATA';
import { Grid, IconButton, Popover, Tooltip, Typography } from '@material-ui/core';
import { fechamentoPeriodoApi } from 'app/services/api/fechamentoPeriodoApi';
import * as Actions from 'app/store/actions';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { FaArrowAltCircleUp } from 'react-icons/fa';
import { MdSettings } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { ContaReceberContext } from '../../contaReceberContext';
import { formatNossoNumero } from '../../contaReceberUtils';
import ContaReceberRecebimentosRealizados from '../ContaReceberRecebimentosRealizados';
import HistoricoContaReceberVisualizacao from '../HistoricoContaReceberVisualizacao';
import { contaReceberModais } from './contaReceberModais';

export const getCurrency = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');
};

const FORMA_RECEBIMENTO = {
  BOLETO: 'Boleto',
  PIX: 'Pix',
  CARTAO_DEBITO: 'Cartão de débito',
  CARTAO_CREDITO: 'Cartão de crédito',
  DINHEIRO: 'Dinheiro',
  TED_DOC: 'TED/DOC',
  CHEQUE: 'Cheque',
  OUTRAS: 'Outras',
};

const ORIGENS_BAIXA = {
  CONTA_RECEBER: 'Conta a receber',
  CONCILIACAO: 'Conciliação bancária',
  ARQUIVO_RETORNO: 'Arquivo retorno',
};

const ORIGENS_LANCAMENTO = {
  CONTA_RECEBER: 'Conta a receber',
  CONTRATO: 'Contratos',
  ADESAO: 'Contratos',
  VENDA: 'Vendas',
  CONCILIACAO: 'Conciliação bancária',
  VENDA_CONTRATO: 'Venda e contrato',
};

const ContaReceberVisualizacaoModal = ({
  onCancelarBaixa,
  semAcoes = false,
  exibirOrigemContaReceber = false,
  origemConciliacao,
}) => {
  const [expanded, setExpanded] = useState('baixa');

  const [contaReceber, setContaReceber] = useContext(ContaReceberContext).contaReceberAtual;
  const [modal, setModal] = useContext(ContaReceberContext).modal;
  const [search] = useContext(ContaReceberContext).search;
  const [page] = useContext(ContaReceberContext).page;
  const [size] = useContext(ContaReceberContext).size;
  const [sort] = useContext(ContaReceberContext).sort;

  // const [anchorEl, setAnchorEl] = useState(null);
  // const [anchorElIndex, setAnchorElIndex] = useState(null);

  // const handleClick = (event, index) => {
  //   setAnchorElIndex(index);
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorElIndex(null);
  //   setAnchorEl(null);
  // };

  const handleCloseModal = () => {
    setContaReceber({});
    setModal('');
  };

  const dispatch = useDispatch();

  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const handleOpenEditMode = async () => {
    const response = await fechamentoPeriodoApi.buscarUltimoPeriodo('RECEBIMENTOS_VENDAS', contaReceber.dataVencimento);
    if (response.data) {
      if (response.data.bloquearAnteriores) {
        if (
          moment(contaReceber.dataVencimento).isSameOrBefore(response.data.periodo) &&
          response.data.funcionalidades.includes('RECEBIMENTOS_VENDAS')
        ) {
          throw showError(
            'Não é possível lançar, editar e excluir contas com data de vencimento referente a um período já fechado no sistema.'
          );
        }
      }
    }
    setModal(contaReceberModais.editarContaReceber);
  };

  const handleOpenBaixarModal = async () => {
    setModal(contaReceberModais.baixarContaReceber);
  };

  const handleExpandedChange = (key, value) => {
    if (value) {
      setExpanded(key);
    } else {
      setExpanded(false);
    }
  };

  const Baixa = ({ values }) => {
    const ultimaDataRecebimento =
      values?.length === 1
        ? values?.[0]?.dataRecebimento
        : values?.sort((a, b) => new Date(b.dataRecebimento) - new Date(a.dataRecebimento))[0]?.dataRecebimento;

    const ultimaDataLiquidacao =
      values?.length === 1
        ? values?.[0]?.dataLiquidacao
        : values?.sort((a, b) => new Date(b.dataLiquidacao) - new Date(a.dataLiquidacao))[0]?.dataLiquidacao;

    let somatorioBaixas;
    let somatorioJuros;
    let somatorioMulta;
    let somatorioDesconto;
    let somatorioCorrecaoMonetaria;

    for (let i = 0; i < values.length; i++) {
      const baixa = values[i];
      if (baixa?.juros) {
        somatorioJuros = somatorioJuros ? somatorioJuros + baixa?.juros?.valorBruto : baixa?.juros?.valorBruto;
      }
      if (baixa?.multa) {
        somatorioMulta = somatorioMulta ? somatorioMulta + baixa?.multa?.valorBruto : baixa?.multa?.valorBruto;
      }
      if (baixa?.desconto) {
        somatorioDesconto = somatorioDesconto
          ? somatorioDesconto + baixa?.desconto?.valorBruto
          : baixa?.desconto?.valorBruto;
      }
      if (baixa?.correcaoMonetaria) {
        somatorioCorrecaoMonetaria = somatorioCorrecaoMonetaria
          ? somatorioCorrecaoMonetaria + baixa?.correcaoMonetaria?.valorBruto
          : baixa?.correcaoMonetaria?.valorBruto;
      }

      somatorioBaixas = somatorioBaixas ? somatorioBaixas + baixa?.valorPago : baixa?.valorPago;
    }
    return (
      <>
        <Grid container style={{ padding: 16 }} spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <DateLabel id="dataRecebimento" label="Data do recebimento" value={ultimaDataRecebimento} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <DateLabel id="dataLiquidacao" label="Data da liquidação" value={ultimaDataLiquidacao} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="formaRecebimento"
              label="Forma de recebimento"
              value={values?.length === 1 ? FORMA_RECEBIMENTO[values?.[0]?.formaRecebimento] : '-'}
            />
          </Grid>
          {values?.baixa?.origemBaixa !== 'CONTA_RECEBER' ? (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel id="origemBaixa" label="Origem da baixa" value={ORIGENS_BAIXA[values?.[0]?.origemBaixa]} />
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}></Grid>
          )}

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="juros" label="Juros (R$)" value={somatorioJuros ? getCurrency(somatorioJuros) : '-'} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="multa" label="Multa (R$)" value={somatorioMulta ? getCurrency(somatorioMulta) : '-'} />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="desconto"
              label="Desconto (R$)"
              value={somatorioDesconto ? getCurrency(somatorioDesconto) : '-'}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="correcaoMonetaria"
              label="Correção monetária (R$)"
              value={somatorioCorrecaoMonetaria ? getCurrency(somatorioCorrecaoMonetaria) : '-'}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="valorRecebido"
              label="Valor recebido (R$)"
              value={somatorioBaixas ? getCurrency(somatorioBaixas) : '-'}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  const CategoriasVisualizar = ({ values }) => {
    const { categorias } = values;

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElIndex, setAnchorElIndex] = useState(null);

    const handleClick = (event, index) => {
      setAnchorElIndex(index);
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorElIndex(null);
      setAnchorEl(null);
    };

    const PopoverHeader = () => (
      <>
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 20,
            paddingBottom: 20,
            paddingLeft: 20,
          }}
        >
          <Grid item md={8} sm={8} xs={8}>
            <Typography
              style={{
                fontWeight: 'bold',
                color: 'rgb(35,61,77)',
                fontSize: 16,
              }}
            >
              Rateio dos centros de custos
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
            <CancelButton title="fechar" type="button" onClick={handleClose}>
              Fechar
            </CancelButton>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            paddingTop: 15,
            paddingLeft: 20,
          }}
        >
          <Grid item md={6} sm={6} xs={6}>
            <Typography
              style={{
                fontWeight: 'bold',
              }}
            >
              Centro de custo
            </Typography>
          </Grid>
          <Grid item md={6} sm={6} xs={6}>
            <Typography
              style={{
                fontWeight: 'bold',
              }}
            >
              Percentual (%)
            </Typography>
          </Grid>
        </Grid>
      </>
    );

    const PopoverContent = ({ rateios }) => (
      <>
        {rateios?.map((rateio) => (
          <Grid container key={rateio.id} style={{ paddingLeft: 20 }}>
            <Grid container>
              <Grid item md={6} sm={6} xs={6}>
                <Grid style={{ marginTop: 5 }}>
                  <Typography>
                    {rateio.classe.indice} {rateio.classe.nome}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Grid style={{ marginTop: 5 }}>
                  <Typography>{rateio.percentual}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </>
    );

    return (
      <Grid item xs={12}>
        <Grid container spacing={3}>
          {categorias?.map((categoria, index) => (
            <ListView
              key={index}
              title="Categoria"
              hideTitle
              hideDivider
              showOnlyFirstLabel
              showMoreTitle="Ver mais categorias"
              values={[categoria]}
              style={{ paddingTop: 0 }}
              options={[
                {
                  title: 'Categoria',
                  name: 'classe.nome',
                  format: (data) => {
                    return `${data.classe.indice}  ${data.classe.nome}`;
                  },
                  grid: { xs: 12, sm: 4 },
                },
                {
                  title: 'Valor bruto (R$)',
                  name: 'valorBruto',
                  format: (data) => getCurrency(data.valorBruto).replace('R$', ''),
                  grid: { xs: 12, sm: 3 },
                },
                {
                  title: '',
                  name: 'rateios',
                  format: () => (
                    <>
                      <Tooltip title="Rateio dos centros de custos" placement="right-end">
                        <IconButton onClick={(event) => handleClick(event, index)}>
                          <MdSettings size={20} style={{ color: 'rgb(35,61,77)' }} />
                        </IconButton>
                      </Tooltip>
                      <Popover
                        open={index === anchorElIndex}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                        PaperProps={{
                          style: { width: 400 },
                        }}
                      >
                        <PopoverHeader />
                        <PopoverContent rateios={categoria.rateios} />

                        <Grid style={{ paddingBottom: 20 }} />
                      </Popover>
                    </>
                  ),
                  grid: { xs: 12, sm: 2 },
                },
              ]}
            />
          ))}
        </Grid>
      </Grid>
    );
  };

  const Content = () => {
    return (
      <div>
        <Grid container style={{ padding: 16 }} spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="competencia" label="Mês competência" value={Competencia(contaReceber?.mesCompetencia)} />
          </Grid>
          {contaReceber?.origemLancamento &&
            (contaReceber?.origemLancamento !== 'CONTA_RECEBER' || exibirOrigemContaReceber) && (
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <TextLabel
                  id="origemLancamento"
                  label="Origem do lançamento"
                  value={ORIGENS_LANCAMENTO[contaReceber?.origemLancamento]}
                />
              </Grid>
            )}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="cliente" label="Cliente" value={contaReceber?.cliente?.pessoa?.nome} />
          </Grid>
          <CategoriasVisualizar values={contaReceber} />
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <DateLabel id="dataVencimento" label="Data do vencimento" value={contaReceber?.dataVencimento} />
          </Grid>
          {contaReceber?.receitaCobranca?.nossoNumero ? (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id="receitaCobranca.nossoNumero"
                label="Nosso número"
                value={formatNossoNumero(contaReceber.receitaCobranca.nossoNumero)}
              />
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextLabel
                id="nossoNumeroAntigo"
                label="Nosso número antigo"
                value={formatNossoNumero(contaReceber?.nossoNumeroAntigo)}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="conta"
              label="Conta"
              value={contaReceber?.baixa?.conta?.descricao || contaReceber?.conta?.descricao}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="documentoFiscal" label="Número do documento fiscal" value={contaReceber?.documentoFiscal} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="observacoes" label="Observações" value={contaReceber?.observacoes} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="dataEmissao" label="Data de emissão" value={DataBR(contaReceber?.dataEmissao)} />
          </Grid>
          {contaReceber?.subJudice && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginBottom: 16 }}>
              <Typography style={{ color: 'red' }}>* Conta a receber definida como sub judice</Typography>
            </Grid>
          )}
        </Grid>

        {contaReceber?.baixas?.length > 0 && (
          <CustomExpandedPanel
            title="Informações da baixa"
            expanded={expanded === 'baixa'}
            onChange={(_, value) => handleExpandedChange('baixa', value)}
          >
            <Grid container spacing={3}>
              <Baixa values={contaReceber?.baixas} />
            </Grid>
          </CustomExpandedPanel>
        )}
        {contaReceber?.baixas?.length > 0 && (
          <CustomExpandedPanel
            title="Recebimentos realizados"
            expanded={expanded === 'recebimentos'}
            onChange={(_, value) => handleExpandedChange('recebimentos', value)}
          >
            <ContaReceberRecebimentosRealizados
              baixas={contaReceber?.baixas}
              showTitle={false}
              showCancelarBaixa={false}
            />
          </CustomExpandedPanel>
        )}
        {contaReceber?.historico?.length > 0 && (
          <CustomExpandedPanel
            title="Histórico de alterações"
            expanded={expanded === 'historico'}
            onChange={(_, value) => handleExpandedChange('historico', value)}
          >
            <HistoricoContaReceberVisualizacao historico={contaReceber.historico} />
          </CustomExpandedPanel>
        )}
      </div>
    );
  };

  const actions = [];

  if (contaReceber.situacao !== 'EXCLUIDA' && permissaoUtils.contaReceber().editar && !semAcoes) {
    if (contaReceber.situacao === 'ABERTA' || contaReceber.situacao === 'PARCIAL') {
      actions.push({ label: 'Editar', onClick: handleOpenEditMode });
    }
  }
  if (contaReceber?.baixas?.length > 0) {
    actions.push({
      label: 'Cancelar baixa',
      onClick: async () => {
        const res = await onCancelarBaixa(
          { selecao: [contaReceber], tipoSelecao: 'NENHUM', params: { q: search } },
          { page, q: search, size, sort }
        );

        if (res) {
          setModal('');
        }
      },
    });
  }
  if (!contaReceber.subJudice && contaReceber.situacao !== 'BAIXADA' && contaReceber.situacao !== 'EXCLUIDA') {
    actions.push({
      label: 'Baixar',
      onClick: handleOpenBaixarModal,
    });
  }

  return (
    <SimpleDialog open={modal === contaReceberModais.visualizarContaReceber} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Lançamento de conta a receber',
          icon: <FaArrowAltCircleUp />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>

              {actions?.length && !origemConciliacao ? <GroupButton actions={actions} label="Ações" /> : undefined}
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default ContaReceberVisualizacaoModal;
